import { Adslot } from '../modules/adslot-controller/adslot.js';
import { EffectFunction } from './index.js';

const sdgCloaked: string = 'sdgCloaked';

export const HIDE_SLOT_CONTAINER: EffectFunction = ({ containerNode }: Adslot) => {
    containerNode.classList.add(sdgCloaked);

    return () => {
        containerNode?.classList.remove(sdgCloaked);
    };
};
